import { isUnifiedPlan } from '../../sdpUtils/sdpSemantics'

/**
 * Finds a transceiver that can be reused.
 * A transceiver can be reused if it satisfies the following conditions:
 *   - it does not have a track on its sender
 *   - it has the same kind (audio or video) as what we specified
 *   - it has been used before (if it has not been used then we are not "reusing" it)
 * @method findReusableTransceiver
 * @param {string} kind The kind of transceiver to find (audio or video)
 * @returns {Object} Transceiver object that matches kind, has no sender track, and has currentDirection. Otherwise undefined.
 */
export default function findReusableTransceiver (kind) {
  const { proxyPeer, config } = this

  if (isUnifiedPlan(config.rtcConfig.sdpSemantics)) {
    const transceivers = proxyPeer.getTransceivers()
    return transceivers.find(
      transceiver =>
        transceiver.sender.track == null &&
        transceiver.receiver &&
        transceiver.receiver.track &&
        transceiver.receiver.track.kind === kind &&
        transceiver.currentDirection // If this has been set, then transceiver has been used before.
    )
  }
}
